import { inventoryApi } from '../api/inventoryApi'

export const getTransactions = async () => {
  try {
    const {
      data: { transactions },
    } = await inventoryApi.getTransactions()
    return transactions
  } catch (error) {
    console.error(`Error fetching inventory transactions: `, error)
    throw error
  }
}
